'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetAmountSelector = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _currencySignFormatter = require('../../utils/currencySignFormatter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresetAmountSelector = exports.PresetAmountSelector = function PresetAmountSelector(_ref) {
  var key = _ref.key,
      amountValue = _ref.amountValue,
      currencyCode = _ref.currencyCode,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      _ref$maxDeposit = _ref.maxDeposit,
      maxDeposit = _ref$maxDeposit === undefined ? '0' : _ref$maxDeposit,
      currentAmountValue = _ref.currentAmountValue,
      _ref$hasPlayerSetAmou = _ref.hasPlayerSetAmount,
      hasPlayerSetAmount = _ref$hasPlayerSetAmou === undefined ? false : _ref$hasPlayerSetAmou,
      updatePlayerSetAmount = _ref.updatePlayerSetAmount;

  var parsedAmountvalue = parseFloat(amountValue);
  var disableTile = parsedAmountvalue > parseFloat(maxDeposit);
  var isCurrentAmountSelected = parseFloat(currentAmountValue) === parsedAmountvalue;
  var shouldHighlight = hasPlayerSetAmount && isCurrentAmountSelected && !disableTile;
  var selectedTileClass = shouldHighlight ? 'qd-amount-button-selected' : '';
  var onClickHandler = function onClickHandler(event) {
    updatePlayerSetAmount(true);
    onClick(event);
  };
  return _react2.default.createElement(
    _buttons.Button,
    {
      className: selectedTileClass + ' qd-amount-button',
      disabled: disableTile,
      type: 'button',
      onClick: onClickHandler,
      tabIndex: tabIndex,
      key: key,
      outfit: 'large'
    },
    (0, _currencySignFormatter.currencySignFormatter)(amountValue, currencyCode)
  );
};